<template>
  <div>
    <view-graphic-area
      v-if="!loading"
      :key="key"
      :sensores="sensores"
      :tipo="componente.value.label"
      :height="componente.value.altura"
      :width="componente.value.largura"
      :periodo="componente.value.periodoInicial"
    />
    <div v-else style="text-align: left">
      <md-progress-spinner
        :md-diameter="50"
        :md-stroke="5"
        md-mode="indeterminate"
      />
    </div>
  </div>
</template>

<script>
import http from '../../../utils/http'
import ViewGraphicArea from './ViewGraphicArea.vue'

export default {
  name: 'ViewShowTimeSeries',
  components: { ViewGraphicArea },
  props: {
    componente: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      key: new Date().getTime(),
      sensores: [],
      loading: true,
    }
  },
  async beforeMount() {
    // set interval to update data every minute
    setInterval(this.updateData, 1000 * 60)

    await this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true

      await Promise.all([
        this.getSensoresVirtuaisData(),
        this.getSensoresData(),
      ])
        .then((values) => {
          this.sensores = values.reduce((acc, e) => [...acc, ...e], [])
          this.updateKey()
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getSensoresData() {
      const response = await http.get(
        `sensor/view/${this.componente.viewId}/${this.componente.id}/time-series`
      )

      return response.sensores.map((e) => ({
        ...e,
        type: 'sensor',
      }))
    },
    async getSensoresVirtuaisData() {
      const response = await http.get(
        `sensor/view/${this.componente.viewId}/${this.componente.id}/time-series/virtual`
      )
      return response.sensoresVirtuais.map((e) => ({
        ...e,
        type: 'virtual',
      }))
    },
    async updateData() {
      const diff = new Date().getTime() - this.key

      const hours = Math.floor(diff / 1000 / 60 / 60)

      if (hours >= 1) {
        await this.loadData()
      }
    },
    updateKey() {
      this.key = new Date().getTime()
    },
  },
}
</script>

<style scoped></style>
